// extracted by mini-css-extract-plugin
export var data_wrapper = "artist-module--data_wrapper--674de";
export var data_wrapper_col = "artist-module--data_wrapper_col--28aac";
export var date = "artist-module--date--dc37e";
export var description = "artist-module--description--08b35";
export var img = "artist-module--img--dd537";
export var img_row_wrapper = "artist-module--img_row_wrapper--d835b";
export var img_wrapper = "artist-module--img_wrapper--f3e8c";
export var media = "artist-module--media--ac147";
export var media_col = "artist-module--media_col--61abd";
export var media_single = "artist-module--media_single--16a9b";
export var media_single_col = "artist-module--media_single_col--d475a";
export var name = "artist-module--name--b1c7e";
export var name_wrapper = "artist-module--name_wrapper--aa07a";
export var performance = "artist-module--performance--226c9";
export var performance_wrapper = "artist-module--performance_wrapper--f0e69";